


class _Date {

    timeSince = (time: number) => {

        var seconds = Math.floor((Date.now() - time) / 1000);
      
        var interval = seconds / 31536000;
      
        if (interval > 1) {
          return `${Math.floor(interval)}yr ago`; //" years";
        }
        interval = seconds / 2592000;
        if (interval > 1) {
          return `${Math.floor(interval)}mo ago`; //" months";
        }
        interval = seconds / 86400;
        if (interval > 1) {
          return `${Math.floor(interval)}d ago`; //" days";
        }
        interval = seconds / 3600;
        if (interval > 1) {
          return `${Math.floor(interval)}h ago`; //" hours";
        }
        interval = seconds / 60;
        if (interval > 1) {
          return `${Math.floor(interval)}m ago`; //" minutes";
        }
        return `just now`; //`${Math.floor(seconds)}s ago`; //" seconds";
      }
}

// export _Date class instance (singleton)
export const __date = new _Date();